import { Textarea } from 'common-front/src/designSystem/form/textarea';
import { TextInput } from 'common-front/src/designSystem/form/textInput';
import { Flex } from 'common/src/designSystem/components/flex';
import { useTranslate } from 'common/src/util/dependencies/dependencies';
import * as React from 'react';
import RoleFormBox from './roleFormBox';
import { Skeleton } from 'common/src/designSystem/components/skeleton';

export const InformationBox = ({ disabled }: { disabled: boolean }) => {
    const translate = useTranslate();

    return (
        <RoleFormBox hideToggle={true} title={translate('informations_su_20567')}>
            <Flex direction="column" gap="6">
                <TextInput
                    disabled={disabled}
                    label={translate('nom_du_r_le_38492')}
                    name="role.name"
                />
                <Textarea
                    disabled={disabled}
                    label={translate('Description')}
                    name="role.description"
                />
            </Flex>
        </RoleFormBox>
    );
};

export const InformationSkeletonBox = () => {
    const translate = useTranslate();

    return (
        <RoleFormBox hideToggle={true} title={translate('informations_su_20567')}>
            <Flex direction="column" gap="6">
                <Skeleton borderRadius="$2" height={64} width="100%" />
                <Skeleton borderRadius="$2" height={126} width="100%" />
            </Flex>
        </RoleFormBox>
    );
};
